import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from '../ui/button';
import Cart from '../Cart/Cart';
import Stepper from './Stepper';

const Header = ({ isEditMode, currentStep, onStepClick }) => {
  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 items-center gap-6">
        {/* Logo/Home */}
        <a href="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <img src="/images/logo.svg" alt="Dekalio" className="h-6 w-6" />
          <span className="font-semibold">Dekalio</span>
        </a>
        
        {/* Center - Stepper */}
        <div className="hidden md:flex flex-1 justify-center">
          <Stepper currentStep={currentStep} onStepClick={onStepClick} />
        </div>

        {/* Right Side Actions */}
        <div className="flex items-center gap-2 ml-auto">
          <Cart />
        </div>

        {/* Mobile Menu */}
        <Button variant="ghost" size="icon" className="md:hidden ml-auto">
          <Menu className="h-5 w-5" />
        </Button>
      </div>
    </nav>
  );
};

export default Header;
